import router from "./router";
import http from "@/utils/axios";
import qs from "qs";
import utils from "@/utils/common";
import userRole from "@/assets/js/userDefaultStyle.js";
import employRole from "@/assets/js/employDefaultStyle.js";
import varStyle from "@/assets/js/varStyle.js";
import vuelazyload from 'vue-lazyload';

/**
 * 往全局样式里添加自定义的皮肤样式
 * @param {*} obj
 */
const styleFormatFun = obj => {
  const html = document.documentElement.style;
  for (const key in varStyle) {
    html.setProperty("--" + varStyle[key], obj[key]);
  }
};
/**
 *
 * @returns 根据当前请求头origin获得租户code接口
 */
const getTenantCodeFun = async () => {
  return http({
    url: "/sys/tenant/config",
    method: "get",
  })
    .then((rps) => {
      if (rps.code == 200 && rps.data) {
        sessionStorage.setItem("tenant_id", rps.data.tenantId);
        sessionStorage.setItem("tenant_code", rps.data.tenantCode);
        return rps.data.tenantCode;
      } else {
        console.log("获取租户code失败");
        return null;
      }
    })
    .catch(() => {
      console.log("获取租户code失败");
      return null;
    });
};
/**
 * 请求获取皮肤接口
 * @param {*} appPlatformType 1用户端，2员工端
 * @param {*} tenantCode 租户code 小程序或者原生APP通过url参数的方式传过来
 * @returns
 */

const getThemeFun = async (appPlatformType = 1, tenantCode) => {
  if (tenantCode && tenantCode != null) {
    return http({
      url: "sys/skin/config/getSkinConfig?appPlatformType=" + appPlatformType + "&tenantCode=" + tenantCode,
      method: "post",
      config: {
        carryToken: false
      }
    })
      .then((rps) => {
        if (rps.code == 200 && rps.data) {
          localStorage.setItem("skinTheme", JSON.stringify(rps.data));
          styleFormatFun(rps.data);
          return rps.data;
        } else {
          console.log("获取皮肤接口失败");
          return null;
        }
      })
      .catch(() => {
        console.log("获取皮肤接口失败");
        return null;
      });
  }
};

/**
 * 格式化路由带过来的tenant_code参数
 * @param {*} code 
 * @returns 
 */
const formatRoutTenantCode = async(code)=>{
  return new Promise((resolve, reject) =>{
    if(typeof code === 'undefined'){
      resolve('')
    }else if(code+ '' === 'null'){
      resolve('')
    }else if(Array.isArray(code)){
      resolve(code.pop())
    }else{
      resolve(code)
    }
  })
}

/**
 * 处理IM传过来的参数
 */
const handlIMParams = (to) => {
  const query = to.query;
  if (query.env === 'webIM') {
    sessionStorage.setItem('env', 'webIM');
  }
  if (query.imaccount && query.imcustomerbranchid) { 
    sessionStorage.setItem('imaccount', query.imaccount) // 蜜蜂客服账号
    sessionStorage.setItem('imcustomerbranchid', query.imcustomerbranchid) // 会话店铺ID
  }
  if (query.source_tenant_code) {
    sessionStorage.setItem('source_tenant_code', query.source_tenant_code);
  }
  window.isWebIM = sessionStorage.getItem('env') === 'webIM';
}

/**
 * 跳转到目的页面前的路由检测
 */
export default Vue => {
  router.beforeEach(async (to, form, next) => {
    console.log("打印进入的路由信息:",to);
    document.title = to.meta.title;
    document["route-page"] = form.fullPath || "";
    handlIMParams(to);
    if (form.fullPath != "/") {
      localStorage.setItem("route", window.decodeURIComponent(form.fullPath));
    }
    let url = location.origin + "/h5user" + to.path;
    let query = qs.stringify(to.query);

    if (query) {
      url = url + "?" + query;
    }
   
    // 如链接本身存在一个token，跳转时app又添加了一个，就会有2个token
    // 此时token为数组，取最后一个
    let token = to.params.token || to.query.token;
    token = Array.isArray(token) ? token.pop() : token;
    if (token) {
      sessionStorage.setItem("token", window.decodeURIComponent(token));
    }
    //切换商场id，由APP传来
    let shop_id = to.params.shopId || to.query.shopId;
    shop_id = Array.isArray(shop_id) ? shop_id.pop() : shop_id;
    if (shop_id) {
      sessionStorage.setItem("shop_id", window.decodeURIComponent(shop_id));
    }
    let tenant_code = to.params.tenant_code || to.query.tenant_code || sessionStorage.getItem("tenant_code");
    let temp_code = await formatRoutTenantCode(tenant_code);
    if (temp_code) {
      sessionStorage.setItem("tenant_code", temp_code);
    }
    if (to.query.utm_methodType_evar) {
      utils.nativeMethod({ tm: 1000005, tp: { utmInfo: to.query } });
      sessionStorage.setItem("utmInfo", JSON.stringify(to.query));
    }
    if (window.tools.isWechat()) {

      Vue.$loading.show();
      if (temp_code) {
        getThemeFun(window.isBeeMiniApp ? 2 : 1, temp_code).then((result) => {
          result && next();
        }).catch(err=>{
          next();
        });
      } else {
        getTenantCodeFun().then((rps) => {
          localStorage.removeItem("skinTheme");
          //小程序跳过来就只是用户端,写死1
          getThemeFun(1, rps).then((result) => {
            result && next();
          }).catch(err=>{
            next();
          });
        });
      }
    } else {
      if (form.name == "home" || form.name == "index") {
        utils.jumpToNewPage({
          url: url,
          noTitle: to.meta.noTitle && to.meta.noTitle == "1" ? "1" : "0",
        });
      } else {
        if (to.name !== "userOrderDetailBysubId") {
          Vue.$loading.show();
        }
        //嵌在app里
        if (localStorage.getItem("skinTheme")) {
          styleFormatFun(JSON.parse(localStorage.getItem("skinTheme")));
          next();
        }
        //浏览器运行、或者app漏传皮肤的数据给h5时
        if (!localStorage.getItem("skinTheme")) {
          //本地ip环境
          if (
            ![
              "demo",
              "pre",
              "preb",
              "prec",
              "prod",
              "prodc",
              "test",
              "testb",
              "testc",
              "testc2",
              "testd",
              "teste",
            ].includes(process.env.VUE_APP_CURRENTMODE)) {
              localStorage.setItem("skinTheme",JSON.stringify({ ...userRole, ...employRole }));
              styleFormatFun({ ...userRole, ...employRole });
              next();
          } else {
            let appPlatformType = window.tools.getClientInfoFun().usertype.indexOf("user") >= 0? "1" : "2";
            if (temp_code) {
              getThemeFun(appPlatformType, temp_code).then((result) => {
                result && next();
              });
            } else {
              getTenantCodeFun().then((rps) => {
                getThemeFun(appPlatformType, rps).then((result) => {
                  result && next();
                });
              });
            }
          }
        }
      }
    }
  });
  router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g
    const isChunkLoadFailed = error.message.match(pattern)
    const targetPath = router.history.pending.fullPath
    if (isChunkLoadFailed) {
      // router.replace(targetPath)
      // window.location.reload()
    }
  })
  
  const _skinTheme = localStorage.getItem("skinTheme") 
  && JSON.parse(localStorage.getItem("skinTheme"))
  || {};
  Vue.mixin({
    beforeCreate() {
      if (!this.$theme) {
        if (_skinTheme) {
          this.$theme = _skinTheme;
        }
        try {
          const theme = localStorage.getItem("skinTheme")
          this.$theme = JSON.parse(theme);
        } catch (error) {
          this.$theme = null;
        }
      }
    },
  });
  Vue.use(vuelazyload, {
    attempt: 2,
    parload: 1.3,
    error: _skinTheme.u_goods_icon_default || require('@/assets/loadingBG.png'),
    loading: _skinTheme.u_goods_icon_default || require('@/assets/loadingBG.png'),
    listenEvents: ['scroll', 'transitionend']
  })
};
